module.exports = __webpack_public_path__ + "img/atendimento_saude.e3cb2a39.svg";